// Modules
import React from 'react';
import cx from 'classnames';
import ImageWrapper from '../HelpComponents/ImageWrapper';
import ImageUploadService from '../../../services/ImageUploadService';
import getImageProcessingLabelKey from '../../../utils/getImageProcessingLabelKey';
// Styles
import * as styles from '../UploadAssetWidget.scss';

const PreviewSingleImage = (properties) => {
  const fetchImageStatus = () => ImageUploadService.getStatus({ imageId: properties.mediaId });

  return (
    <div
      className={cx(styles.singleImage, styles.imageContainer, properties.singleImageClass)}
      data-id={properties.index}
    >
      <ImageWrapper
        id={properties.id}
        index={properties.index}
        image={properties.image}
        angle={properties.relativeAngle}
        uploadInProgress={properties.uploadInProgress}
        mediaId={properties.mediaId}
        fetchStatus={fetchImageStatus}
        getLabelKey={getImageProcessingLabelKey}
        isPending={properties.isPending}
        hasError={properties.hasError}
        onMediaStatusChange={properties.onMediaStatusChange}
        compact={properties.compact}
      />
      <span
        className={styles.rotate}
        onClick={properties.rotateImage}
      >
        {properties.deleteFileTitle}
      </span>
      <span
        className={styles.dot}
      />
      <span
        className={styles.delete}
        onClick={properties.deleteImage}
      >
        {properties.rotateImageTitle}
      </span>
    </div>
  );
};

export default PreviewSingleImage;
